import type { FirestoreContainer } from './FirestoreContainer.js';

import { createContainer } from '@elara/core/di';

import { createClientPlaceModel } from '#models/PlaceModel.js';

/**
 * Client-side Places Container for dependency injection.
 * Exposes the Place model for loading place documents by id (e.g. from recommendation widgets).
 */
export function createPlacesContainer(firestore: FirestoreContainer) {
  const $places = createContainer('places').providedLazy('ClientPlace', () => createClientPlaceModel(firestore));
  return $places;
}

export type $PlacesContainer = ReturnType<typeof createPlacesContainer>;
export type PlacesContainer = $PlacesContainer['use'];
